// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PrinterFilledSvg from "@fishx/icons-svg/es/asn/PrinterFilled";
import FishxIcon from '../components/FishxIcon';

var PrinterFilled = function PrinterFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PrinterFilledSvg
  }));
};

PrinterFilled.displayName = 'PrinterFilled';
export default React.forwardRef(PrinterFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PrinterFilled.js
// module id = 3837
// module chunks = 0